import React from 'react';
import PropTypes from 'prop-types';
import ConfigAssistantListGroup from './ConfigAssistantListGroup';
import ConfigAssistantListOption from './ConfigAssistantListOption';

const ConfigAssistantNestedListView = ({
  data,
  selectedOption,
  renderLabel,
  renderGroupIcon,
  renderOptionIcon,
  onChange
}) => {
  return data.map((group, index) => {
    const { header, options } = group;
    return (
      <ConfigAssistantListGroup
        key={index}
        header={header}
        icon={renderGroupIcon ? renderGroupIcon(group) : null}>
        {options.map((option, index) => (
          <ConfigAssistantListOption
            key={index}
            label={renderLabel(option)}
            checked={option === selectedOption}
            icon={renderOptionIcon ? renderOptionIcon(option) : null}
            onChange={() => onChange(option)}
          />
        ))}
      </ConfigAssistantListGroup>
    );
  });
};

ConfigAssistantNestedListView.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      header: PropTypes.string.isRequired,
      options: PropTypes.array.isRequired
    })
  ).isRequired,
  selectedOption: PropTypes.object,
  renderLabel: PropTypes.func.isRequired,
  renderGroupIcon: PropTypes.func,
  renderOptionIcon: PropTypes.func,
  onChange: PropTypes.func.isRequired
};

export default ConfigAssistantNestedListView;
